
import React from 'react';

const FundCard = ({ title, desc, icon }: { title: string, desc: string, icon: string }) => (
  <div className="p-10 bg-white border border-slate-200 hover:border-black transition-all group">
    <div className="w-14 h-14 bg-slate-50 rounded-none flex items-center justify-center mb-8 group-hover:bg-black transition-all">
      <i className={`fas ${icon} text-slate-900 group-hover:text-white text-xl`}></i>
    </div>
    <h3 className="text-xl font-black text-slate-900 mb-6 uppercase tracking-tighter">{title}</h3>
    <p className="text-sm text-slate-500 leading-relaxed font-medium mb-10">{desc}</p>
    <button className="w-full py-4 border-2 border-black text-xs font-black uppercase tracking-[0.2em] hover:bg-black hover:text-white transition-all">Contribute</button>
  </div>
);

const Donate: React.FC = () => {
  return (
    <div className="py-24 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mb-24">
          <div className="text-[10px] font-bold uppercase tracking-[0.3em] text-slate-400 mb-8">Invest in independence</div>
          <h1 className="text-6xl font-black text-slate-900 mb-8 tracking-tighter">Support the Mission</h1>
          <p className="text-xl text-slate-600 font-medium leading-relaxed">
            We do not accept government grants or corporate sponsorships that would compromise our editorial integrity. Our work is powered entirely by independent contributors.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-24">
          <FundCard 
            title="Investigative Fund"
            desc="Directs resources toward high-stakes inquiries into regulatory capture and systemic institutional failure."
            icon="fa-magnifying-glass-chart"
          />
          <FundCard 
            title="Legal Defense Fund"
            desc="Protects the right to report against meritless intimidation tactics and 'SLAPP' lawsuits globally."
            icon="fa-gavel"
          />
          <FundCard 
            title="Global Consumer Defense"
            desc="Providing the legal and investigative shield for those who expose international corruption and corporate neglect."
            icon="fa-earth-americas"
          />
        </div>

        <div className="bg-white border border-slate-200 p-12 text-center">
            <h3 className="text-sm font-black uppercase tracking-[0.4em] text-slate-400 mb-8">Autonomous Contribution Portal</h3>
            <div className="flex flex-wrap justify-center gap-4">
                <button className="px-8 py-4 bg-slate-50 text-slate-900 font-bold text-xs uppercase tracking-widest border border-slate-200 hover:bg-black hover:text-white transition-all">Bitcoin (BTC)</button>
                <button className="px-8 py-4 bg-slate-50 text-slate-900 font-bold text-xs uppercase tracking-widest border border-slate-200 hover:bg-black hover:text-white transition-all">Monero (XMR)</button>
                <button className="px-8 py-4 bg-slate-50 text-slate-900 font-bold text-xs uppercase tracking-widest border border-slate-200 hover:bg-black hover:text-white transition-all">Ethereum (ETH)</button>
                <button className="px-8 py-4 bg-slate-50 text-slate-900 font-bold text-xs uppercase tracking-widest border border-slate-200 hover:bg-black hover:text-white transition-all">Fiat (Stripe)</button>
            </div>
            <p className="text-[10px] text-slate-400 mt-10 uppercase tracking-widest">System Audit is a non-profit investigative body. Contributions are used solely for mission-critical operations.</p>
        </div>
      </div>
    </div>
  );
};

export default Donate;
